import React, { useState, useEffect } from "react";
import { connect, useSelector } from "react-redux";
import { useLocation, Redirect, Link } from "react-router-dom";
import {
  signIn,
  resetSignIn,
  signInGoogle,
  signInFacebook,
  signInApple,
  getRegisterOtp,
} from "../../actions/auth-action";
import { changeTimezone } from "../../actions/setting-action";
import {
  Container,
  Row,
  Col,
  Form,
  Button,
  Alert,
  Card,
} from "react-bootstrap";
import { GoogleLogin } from "react-google-login";
import FacebookLogin from "react-facebook-login/dist/facebook-login-render-props";
import AppleLogin from "react-apple-login";
import "./Login.scss";
import { getCurrentTimeZone } from "../../utils/Utils";
import Header from "../common/HeaderGuest";
import Footer from "../common/Footer";
import queryString from "query-string";
import { t } from "i18next";
import { useTranslation } from "react-i18next";
import GoogleLoginComponent from "./GoogleLoginComponent";
import HeaderGuest from "../common/HeaderGuest";
import GuestContainer from "./GuestContainer";
import BiometricLogin from "./BiometricLogin";
import BiometricLoginModal from "./BiometricLoginModal";
import AuthLogo from "./AuthLogo";
import AppDownloadBanner from "../common/AppDownloadBanner";

const Login = (props) => {
  const {
    resetSignIn,
    signIn,
    signInGoogle,
    signInFacebook,
    signInApple,
    getData,
  } = props;
  const location = useLocation();
  const host = window.location.origin;
  const hash = window.location.hash;
  const token = useSelector((state) => state.auth.token);
  const user = useSelector((state) => state.auth.user);
  const errorMessage = useSelector((state) => state.auth.errorMessage);
  const signInStart = useSelector((state) => state.auth.signInStart);
  const { search } = useLocation();
  const { t } = useTranslation();
  const query = queryString.parse(search);
  const pathname = "/bots";
  const gaConfirmed = useSelector((state) => state.auth.gaConfirmed);
  const gaEnabled = useSelector((state) => state.settings.gaEnabled);
  const [isOpen, setIsOpen] = useState(false);

  const [email, setEmail] = useState("");
  const [pass, setPass] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const clientId = '99775611904-eon95ujc9qgaasgd5q9m2aulttj01op0.apps.googleusercontent.com';


  useEffect(() => {
    resetSignIn();
    return () => resetSignIn();
  }, []);
  

  useEffect(() => {
    const currentTimezone = getCurrentTimeZone();
    window.timezone = currentTimezone;
  }, []);

  const login = (e) => {
    e.preventDefault();
    signIn(email, pass);
  };

  const loginGoogle = (res) => {
    const { tokenId } = res;
    signInGoogle(tokenId);
  };

  const loginFacebook = (res) => {
    const { accessToken, userID } = res;
    signInFacebook(accessToken, userID);
  };

  const loginApple = (res) => {
    console.log("Apple", res);
  };

  const failedLoginGoogle = (res) => {
    console.log("Failed login Google", res);
  };

  useEffect(() => {
    if (hash) {
      const idTokenIndex = hash.indexOf("id_token");
      const idToken = hash.slice(idTokenIndex + 9);
      signInApple(idToken);
    }
  }, [hash]);

  if (token) {
    // if (user && user.email_verified_at) {
    //   if (gaEnabled && !gaConfirmed) return <Redirect to="/ga/confirm" />;
    //   return <Redirect to={pathname} />;
    // }
    if (user) {
      if (gaEnabled && !gaConfirmed) return <Redirect to="/ga/confirm" />;
      return <Redirect to={pathname} />;
    }
    return <Redirect to="/bots" />;
  }

  return (
    <>
    <div className="login-redesign-container">
        {/* Left Panel */}
        <div className="login-left-panel">
          <div className="login-content">
              <AuthLogo />
              <div className="mb-4">
                  {/* <h1 className="login-title">Log in to your account.</h1> */}
                  <p className="login-subtitle">Enter your email address and password to log in</p>
              </div>
              <form>
                <div className="login-input-group mb-3">
                  <img src="/images/email_icon_new.svg" className="input-icon" alt="email" />
                  <input
                    type="email"
                    placeholder="Email Address"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="form-control login-input-transparent"
                  />
                </div>
                
                <div className="login-input-group mb-2">
                  <img src="/images/password_icon_new.svg" className="input-icon" alt="password" />
                  <input
                    type={showPassword ? "text" : "password"}
                    placeholder="Password"
                    value={pass}
                    onChange={(e) => setPass(e.target.value)}
                    className="form-control login-input-transparent"
                    autoComplete="new-password"
                  />
                  {/* Eye icon inside input */}
                  <span className="password-toggle-icon" onClick={() => setShowPassword(!showPassword)}>
                     <i className={`fa-regular ${showPassword ? "fa-eye" : "fa-eye-slash"}`} style={{color: '#333'}}></i>
                  </span>
                </div>

                <div className="d-flex justify-content-end mb-4">
                  <a href="/forget-pass" className="forgot-password-link">Forgot password?</a>
                </div>
                
                <button type="submit" onClick={login} className="btn btn-primary w-100 btn-login-new">
                  Login
                </button>
                
                <Alert
                  show={errorMessage != null}
                  variant="danger"
                  className="mt-2"
                >
                  {errorMessage && errorMessage}
                </Alert>
              </form>
              <div className="text-center mt-4 mb-3 position-relative">
                   <span className="login-divider-text">or Login With</span>
              </div>
              
              <ul className="d-flex justify-content-center gap-3 p-0 list-unstyled mb-5">
                {/* 
                <li><FacebookLogin ... /></li> 
                */}
                <li> <GoogleLoginComponent clientId={clientId}></GoogleLoginComponent></li>
                <li> <div className="circle text-center social-circle" onClick={()=>setIsOpen(true)}>
                        <a href="#">
                        <img src="/images/fingerprint.svg" alt="Biometric"/>
                        </a>
                    </div></li>
                {/* <li><AppleLogin ... /></li> */}
              </ul>

              <div className="text-center mt-4">
                 <span className="text-secondary">{t("no-acc")} </span>
                 <Link to="/signup" className="text-primary fw-bold text-decoration-none">{t("create-acc")}</Link>
              </div>
          </div>
          <div style={{ padding: '2rem' }}>
            
          </div>
         
        </div>

        {/* Right Panel */}
        <div className="login-right-panel d-none d-lg-block">
            <div className="hero-image-wrapper">
                <img src="/images/new-login-bg.png" alt="Login Hero" />
                <div className="auth-hero-download">
                  <AppDownloadBanner variant="auth" />
                </div>
            </div>
        </div>
    </div>
    <BiometricLoginModal isOpen={isOpen} onClose={()=>setIsOpen(false)}></BiometricLoginModal>
      
    </>
  );
};
export default connect(null, {
  signIn,
  resetSignIn,
  signInGoogle,
  signInFacebook,
  signInApple,
  changeTimezone,
  getRegisterOtp,
})(Login);
